import axios from "axios";
import { axiosApiInstance } from "../utils/axiosApiInstance";
import { env } from "../utils/envConfig";

const baseUrl = `${env.REACT_APP_BACKEND_APP_NAME}/api`;

export const createFeedback = async(params, convId, seqId) => {
  try {
    const res = await axiosApiInstance.put(`${baseUrl}/conversation/${convId}/message/${seqId}/feedback`, params);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getFeedback = async() => {
  try {
    const res = await axiosApiInstance.get(`${baseUrl}/feedback`);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getMsgFeedback = async(convId, seqId) => {
  try {
    const res = await axiosApiInstance.get(`${baseUrl}/conversation/${convId}/message/${seqId}/feedback`);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const deleteFeedback = async(convId, seqId) => {
  try {
    const res = await axiosApiInstance.delete(`${baseUrl}/conversation/${convId}/message/${seqId}/feedback`);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getIdentifierMappings = async() => {
  try {
    const res = await axiosApiInstance.get(`${baseUrl}/identifier-mappings`);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getAccessToken = async(password) => {
  try {
    const res = await axios.post(`${baseUrl}/auth/token`, { password });
    const token = res.data.access_token;
    sessionStorage.setItem('token', token);
    try {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      sessionStorage.setItem('is_admin', payload.role === 'admin' ? '1' : '0');
    } catch {}
    return res;
  } catch (err) {
    return err.response;
  }
};